/**
 * Query key utilities for roles hooks
 * Keys match backend controller method names
 */
export const rolesKeys = {
  findAll: () => ["roles", "findAll"] as const,
  findOne: (roleUuid: string) => ["roles", "findOne", roleUuid] as const,
} as const

/**
 * Query key utilities for role assignments hooks
 * Keys match backend controller method names
 */
export const roleAssignmentsKeys = {
  findByRole: (roleUuid: string) =>
    ["role-assignments", "findByRole", roleUuid] as const,
} as const

/**
 * Query key utilities for group role assignments hooks
 * Keys match backend controller method names
 */
export const groupRoleAssignmentsKeys = {
  findByRole: (roleUuid: string) =>
    ["group-role-assignments", "findByRole", roleUuid] as const,
} as const

/**
 * Query key utilities for member roles hooks
 * Keys match backend controller method names
 */
export const memberRolesKeys = {
  findByMember: (memberUuid: string) =>
    ["member-roles", "findByMember", memberUuid] as const,
} as const

/**
 * Query key utilities for member permissions hooks
 * Keys match backend controller method names
 */
export const memberPermissionsKeys = {
  findByMember: (memberUuid: string) =>
    ["member-permissions", "findByMember", memberUuid] as const,
} as const
